import React from 'react';
import EDDivider from '../../BaseComponents/Divider/EDDivider';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDStaticProgress from '../../BaseComponents/ProgressIndicators/StaticProgress/EDStaticProgress';
import BakgrundsjobbItem from './Components/BakgrundsjobbItem';
import { ISysJobb } from './BakgrundsjobbQuery';
import { TEDSYSJobbSTATUSEnum } from '../../globalQueryTypes';
import EDIcon from '../../BaseComponents/Icon/EDIcon';

interface IProps {
  jobb: ISysJobb[];
}

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  itemContainer: {
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
  },
  fullWidth: {
    width: '100%',
  },
  progressMargin: {
    marginRight: 4,
  },
  emptyText: {
    color: theme.customProperties.Fade.DarkOnLight.mediumEmphasis,
  },
}));

/**
 * En listvy av bakgrundsjobb
 */
const Bakgrundsjobb: React.FC<React.PropsWithChildren<IProps>> = ({ jobb }) => {
  const { classes } = useStyles();

  const renderStatus = (jobb: ISysJobb) => {
    switch (jobb.status) {
      case TEDSYSJobbSTATUSEnum.KLART:
        return (
          <EDIcon
            iconType="check_circle_outline"
            size="large"
            color="primary"
          />
        );
      case TEDSYSJobbSTATUSEnum.VILANDE:
        return <EDIcon iconType="pause_circle_outline" size="large" />;
      case TEDSYSJobbSTATUSEnum.PAUSAT:
        return <EDIcon iconType="pause_circle_outline" size="large" />;
      default:
        return (
          <EDStaticProgress
            value={jobb.progress * 100}
            size={40}
            classes={{
              root: classes.progressMargin,
              overlay: classes.progressMargin,
            }}
          />
        );
    }
  };

  return (
    <>
      {jobb.length === 0 && (
        <EDTypography variant="subtitle1" className={classes.emptyText}>
          Inga beställda jobb
        </EDTypography>
      )}
      {jobb.map((j, index) => (
        <React.Fragment key={index}>
          <div className={classes.container}>
            <div className={classes.fullWidth}>
              <EDTypography variant="subtitle1">{j.title}</EDTypography>
              <div className={classes.itemContainer}>
                <BakgrundsjobbItem
                  title="Start:"
                  value={`${j.start.toLocaleDateString(
                    'sv-SE'
                  )} ${j.start.toLocaleTimeString('sv-SE', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}`}
                />
                <BakgrundsjobbItem
                  title="Ber. tid:"
                  value={
                    j.status === TEDSYSJobbSTATUSEnum.KLART
                      ? 'Klar'
                      : !j.minutesLeft
                      ? 'Ej påbörjad'
                      : `${j.minutesLeft} min, klart ca: ${j.end.toLocaleString(
                          'sv-SE',
                          {
                            hour: '2-digit',
                            minute: '2-digit',
                          }
                        )}`
                  }
                />
                <BakgrundsjobbItem title="Startad av:" value={j.user} />
              </div>
            </div>
            {renderStatus(j)}
          </div>
          {index !== jobb.length - 1 && <EDDivider marginY={1} />}
        </React.Fragment>
      ))}
    </>
  );
};

export default Bakgrundsjobb;
